module.exports = __webpack_public_path__ + "48b4ef2f307c5745bdea89e204a23cf3.svg";